
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { HuntTypeCard } from "@/components/hunting/HuntTypeCard";
import { PackageSection } from "@/components/hunting/PackageSection";
import { ComingSoonAlert } from "@/components/hunting/ComingSoonAlert";
import { DynamicImageGallery } from "@/components/hunting/DynamicImageGallery";

export interface HuntType {
  id: string;
  title: string;
  season?: string;
  description: string;
  huntingArea?: string;
  successRate?: number;
  pictures?: Array<{
    src: string;
    description: string;
  }>;
}

interface HuntTypesSectionProps {
  huntTypes: HuntType[];
  activeHuntTab: string;
  setActiveHuntTab: (id: string) => void;
  selectedPackage: string | null;
  setSelectedPackage: (id: string | null) => void;
  handleSelectHunt: (huntId: string) => void;
  handleReserveClick: () => void;
}

export const HuntTypesSection: React.FC<HuntTypesSectionProps> = ({
  huntTypes,
  activeHuntTab,
  setActiveHuntTab,
  selectedPackage,
  setSelectedPackage,
  handleSelectHunt,
  handleReserveClick,
}) => {
  return (
    <section className="py-10 px-4 md:px-8 max-w-7xl mx-auto">
      <h2 className="text-3xl font-bold mb-6 text-tribal-secondary">Available Hunt Types</h2>
      
      <Tabs value={activeHuntTab} onValueChange={handleSelectHunt} className="w-full">
        <TabsList className="grid grid-cols-3 mb-8">
          {huntTypes.map(hunt => (
            <TabsTrigger 
              key={hunt.id} 
              value={hunt.id} 
              className="text-sm md:text-base"
            >
              {hunt.title}
            </TabsTrigger>
          ))}
        </TabsList>
        
        {huntTypes.map(hunt => (
          <TabsContent key={hunt.id} value={hunt.id} className="space-y-6">
            {hunt.id === "pictures" ? (
              <DynamicImageGallery 
                gallerySlug="hunting" 
                fallbackImages={hunt.pictures || []}
              />
            ) : (
              <>
                <div className="grid md:grid-cols-1 gap-6 mb-8">
                  <HuntTypeCard {...hunt} isSelected={true} onClick={() => {}} />
                </div>
                
                {hunt.id === "antelope" ? (
                  <PackageSection 
                    huntTypeId={hunt.id}
                    selectedPackage={selectedPackage}
                    setSelectedPackage={setSelectedPackage}
                    handleReserveClick={handleReserveClick}
                  />
                ) : (
                  <ComingSoonAlert huntType={hunt.id} />
                )}
              </>
            )}
          </TabsContent>
        ))}
      </Tabs>
    </section>
  );
};
